import {Platform, StyleProp, ViewStyle} from 'react-native';
import React, {useMemo} from 'react';
import {useColorThemeType, useShadow} from '../../../appStyles/hooks/theme';

import {BackButtonProps} from './type';
import {Box} from '../../core/view';
import {ChevronLeftIcon} from 'native-base';
import {PButton} from '../../core/Button';
import {getWidth} from '../../../utils/common';

const BackButton: React.FC<BackButtonProps> = React.forwardRef((props, ref) => {
  const theme = useColorThemeType();
  const shadow = useShadow('9');
  const width = 40,
    height = 40;
  const buttonStyle: StyleProp<ViewStyle>[] = [
    {
      width: getWidth(width),
      height: height,
      borderRadius: 50,
      shadowColor: theme?.shadow[100],
    },
    props.style,
  ];
  const iconBoxStyle: StyleProp<ViewStyle>[] = [
    {
      width: getWidth(width),
      height: height,
      justifyContent: 'center',
    },
  ];

  const getChevronSize = useMemo(() => {
    if (Platform.OS === 'android') return '4';
    return '6';
  }, []);
  return (
    <PButton
      {...props}
      accessibilityLabel={'backbutton'}
      bgColor={theme?.background.white[100]}
      style={[buttonStyle, shadow]}
      hideTitle={true}
      leftComponent={
        <Box style={iconBoxStyle}>
          <ChevronLeftIcon
            alignSelf="center"
            size={getChevronSize}
            color={theme?.icon.gray[100]}
          />
        </Box>
      }
      ref={ref}
    />
  );
});

export default React.memo(BackButton);
